module.exports = __webpack_public_path__ + "static/gallery_peak_6_thumb-f3688009ad6dfcb14473a7da0aa187e7.jpg";